import { request } from "../utils/request";
import { BACKEND_BASE_URL } from "./Resolver";

type UIConfigurationType = {
  notification_enabled: boolean;
  primary_account_name: string;
  secondary_account_name: string;
  cors_allowed_origin: string;
};

export class UIConfiguration {
  public static async get(): Promise<UIConfigurationType> {
    const url = new URL(`${BACKEND_BASE_URL}/api/v1/ui_configuration`);
    const response = await request(url, { method: "GET" }, false);
    return await response.json();
  }
}
